import { useQuery } from '@tanstack/react-query';
import { ApiEndpoints } from '../../../../constants/endpoints/apiEndpoints';
import { getAxios } from '../../../../lib/axios';
import { AgentActivityReportDetailRow } from '../types';

export function useMyReportQuery(
  startDate: string | undefined,
  endDate: string | undefined,
  flsqNumber: string | undefined
) {
  return useQuery({
    queryKey: ['myReport', startDate, endDate, flsqNumber],
    queryFn: async () => {
      const url = ApiEndpoints.reporting.agentActivityReport.myReport(startDate, endDate, flsqNumber);
      return (await getAxios().get<AgentActivityReportDetailRow[]>(url)).data;
    }
  });
}
